<template>
    <label
        :class="[
            'relative inline-flex items-center h-6 min-w-12 flex-shrink-0 rounded-full transition-colors cursor-pointer',
            colorClass
        ]"
    >
        <input
            type="checkbox"
            class="sr-only"
            :checked="value"
            v-bind="$attrs"
            @change="onChange"
        />

        <span
            v-if="$slots.default || $slots.on || $slots.off"
            :class="[
                'absolute inset-0 flex items-center px-1.5 text-xs font-semibold leading-none text-theme-inverse',
                value ? 'justify-start' : 'justify-end'
            ]"
        >
            <template v-if="value">
                <slot name="on"><slot></slot></slot>
            </template>
            <template v-else>
                <slot name="off"><slot></slot></slot>
            </template>
        </span>

        <span
            :class="[
                'absolute top-0.5 flex items-center justify-center w-5 h-5 rounded-full bg-theme-card shadow transition-all',
                value ? 'right-0.5' : 'left-0.5'
            ]"
        >
            <slot name="circle"></slot>
        </span>
    </label>
</template>

<script>
export default {
    name: "CustomSwitch",
    inheritAttrs: false,
    props: {
        value: { type: Boolean, default: false },
        success: { type: Boolean, default: false },
        danger: { type: Boolean, default: false }
    },
    computed: {
        colorClass() {
            if (this.value) {
                return this.success ? "bg-theme-success" : "bg-theme-primary";
            }
            return this.danger ? "bg-theme-danger" : "bg-theme-muted";
        }
    },
    methods: {
        onChange(evt) {
            this.$emit("input", evt.target.checked);
            this.$emit("change", evt);
        }
    }
};
</script>
